const CATEGORY_COLOR_PALETTE: Array<{ bg: string; fg: string }> = [
  { bg: '#FFE8CC', fg: '#7A4100' }, // warm orange
  { bg: '#E3FAFC', fg: '#0B5D6B' }, // cyan
  { bg: '#E6FCF5', fg: '#0B6B44' }, // teal/green
  { bg: '#F3F0FF', fg: '#4A2A8A' }, // violet
  { bg: '#FFF3BF', fg: '#8A5A00' }, // amber
  { bg: '#E7F5FF', fg: '#0A4B84' }, // blue
  { bg: '#FFE3E3', fg: '#8C1F1F' }, // red
  { bg: '#F8F0FC', fg: '#6D2E7A' }, // magenta
  { bg: '#F1F3F5', fg: '#344054' }, // slate
  { bg: '#D3F9D8', fg: '#1F5F2A' }, // leaf
];

function hashCategoryName(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i += 1) {
    h = (h * 31 + name.charCodeAt(i)) >>> 0;
  }
  return h;
}

export function incomeExpenseChipSx(value: string | number | null | undefined) {
  const lower = String(value ?? '').trim().toLowerCase();
  if (lower === 'in' || lower === 'income') {
    return {
      backgroundColor: '#BBF7D0',
      color: '#14532D',
      borderColor: '#4ADE80',
    };
  }
  if (lower === 'out' || lower === 'expense') {
    return {
      backgroundColor: '#FEE2E2',
      color: '#991B1B',
      borderColor: '#FCA5A5',
    };
  }
  if (lower === 'n/a' || lower === 'na') {
    return {
      backgroundColor: '#E9ECEF',
      color: '#495057',
      borderColor: '#DEE2E6',
    };
  }
  return {};
}

export function categoryChipSx(categoryName: string | number | null | undefined) {
  const raw = String(categoryName ?? '').trim();
  if (!raw) return {};
  const lower = raw.toLowerCase();
  if (
    lower === 'in' ||
    lower === 'out' ||
    lower === 'income' ||
    lower === 'expense' ||
    lower === 'n/a' ||
    lower === 'na'
  ) {
    return incomeExpenseChipSx(raw);
  }
  if (lower.includes('unclassified')) {
    return {
      backgroundColor: '#FFF4CC',
      color: '#8A5A00',
      borderColor: '#FFD666',
    };
  }

  const pick = CATEGORY_COLOR_PALETTE[hashCategoryName(lower) % CATEGORY_COLOR_PALETTE.length];
  return {
    backgroundColor: pick.bg,
    color: pick.fg,
    borderColor: pick.bg,
  };
}
